/**
 * Enables any element after a form submission.
 *
 * example: <form data-submit-once="#mySubmitButton"> <!-- This will disable the button
 * 'mySubmitButton' when <form> 'submit' event is fired.
 */
export class SubmitOnce {

  constructor() {

    $('[data-submit-once]').on('submit', function() {
      const wasSubmitted = $(this).data('submitted');
      const submitButtonSelector = $(this).attr('data-submit-once');

      if (!wasSubmitted) {
        $(this).data('submitted', true);

        if (submitButtonSelector) {
          $(submitButtonSelector).attr('disabled', 'disabled');
        }

      } else {
        return false;
      }
    });
  }
}